module.exports = __webpack_public_path__ + "img/image00005-min.2a169ff3.jpeg";